export default __webpack_public_path__ + "croix.svg";